import {UiSchema} from '@rjsf/utils';

export const getUiOptions = <T extends Record<string, unknown>>(uiSchema: UiSchema) => {
  return (uiSchema['ui:options'] as T | undefined) ?? ({} as T);
};
